export const updateText = (
  prefix: string,
  item: string | null | undefined,
  suffix = '',
): string => (item ? `${prefix}${item}${suffix}` : '');
